import ButtonWithLoader from "@/common/components/ui/loading/ButtonLoading";

interface TableCursorFooterProps {
  onLoadMore: () => void;
  hasNextPage?: boolean;
  isFetchingNextPage?: boolean;
}

const TableCursorFooter: React.FC<TableCursorFooterProps> = ({
  onLoadMore,
  hasNextPage,
  isFetchingNextPage,
}) => {
  return (
    <div className="flex justify-center mt-4">
      {hasNextPage && (
        <ButtonWithLoader
          onClick={onLoadMore}
          isLoading={isFetchingNextPage}
          disabled={!hasNextPage || isFetchingNextPage}
        >
          {isFetchingNextPage ? "Carregando mais..." : "Carregar Mais"}
        </ButtonWithLoader>
      )}
    </div>
  );
};

export default TableCursorFooter;
